var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { "no-padding": "", subtitle: _vm.subtitle } }),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { dark: "", grow: "", centered: "" },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { href: "#tab-1" } },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("compare")]),
              _vm._v("Guidelines\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab",
            { attrs: { href: "#tab-2" } },
            [
              _c("v-icon", { staticClass: "mr-1" }, [_vm._v("functions")]),
              _vm._v("Cofactors\n    "),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "tab-1" } },
            [_c("TenantGuidelinesManage")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "tab-2" } },
            [_c("CoFactorManage")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }